import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "rating-recap",
  class: "no-mobile"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("tr", { class: "headings" }, [
  /*#__PURE__*/_createElementVNode("td", null, " Note attribuée "),
  /*#__PURE__*/_createElementVNode("td", null, " Consulter les avis pour... "),
  /*#__PURE__*/_createElementVNode("td", null, " Résumé des notes ")
], -1)
const _hoisted_3 = { style: {"width":"90%","margin":"auto"} }
const _hoisted_4 = { class: "bar-container-sup" }
const _hoisted_5 = { class: "avis-heading" }
const _hoisted_6 = { class: "bar-container" }
const _hoisted_7 = {
  style: {"width":"100%"},
  class: "bar-grey"
}
const _hoisted_8 = { class: "avis-count" }
const _hoisted_9 = { class: "avis-type" }
const _hoisted_10 = { class: "avis-summary" }
const _hoisted_11 = { class: "stars-block" }
const _hoisted_12 = { class: "grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, [
        _createElementVNode("table", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.notes.note, (note, type) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(type), 1),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    style: _normalizeStyle('width:'+ note.percent +'%;'),
                    class: "bar-green"
                  }, null, 4)
                ])
              ]),
              _createElementVNode("td", _hoisted_8, _toDisplayString(note.nb), 1)
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("td", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.notes.type, (note, type) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("div", null, _toDisplayString(type), 1),
            _createElementVNode("div", null, _toDisplayString(note), 1)
          ]))
        }), 256))
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.gm.notes.sum, (note, type) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", null, _toDisplayString(type), 1),
              _createElementVNode("span", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                      return _createVNode(_component_font_awesome_icon, {
                        key: index,
                        icon: "star"
                      })
                    }), 64))
                  ]),
                  _createElementVNode("div", {
                    class: "gold",
                    style: _normalizeStyle({ width : ( note / 5 * 100 ) + '%' })
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                      return _createVNode(_component_font_awesome_icon, {
                        key: index,
                        icon: "star"
                      })
                    }), 64))
                  ], 4)
                ])
              ])
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}